(function () {
  console.log("global.js loaded");

  const COLOR_MAP = {
    "red": "#C21E1E",
    "black": "#000000",
    "beige": "#dbbcaa",
    "desert": "#C2A482",
    "off white": "#EFEDE8",
    "ecru": "#E1D8C5",
    "pink": "#E91E63",
    "candy pink": "#FF80AB",
    "baby blue": "#89CFF0",
    "baby pink": "#F4C2C2",
    "baby yellow": "#FCEF91",
    "sage green": "#9AAB89",
    "burgundy": "#800020",
    "mocha": "#967969",
    "pink nude": "#F2DADF",
    "dark taupe": "#D2C9C7",
    "taupe": "#8f7c6b",
    "ash brown": "#462825",
    "fire red": "#ff0000",
    "oatmeal": "#D8C29D",
    "dark beige": "#CBB595",
    "crystal pink": "#EDD0CE",
    "arctic ice": "#A7C9E3",
    "ash grey": "#B2BEB5",
    "sky blue": "#87CEEB",
    "neon orange": "#F18F2B",
    "mint": "#6fddc7",
    "silver lake blue": "#3892d8",
    "soft violet": "#9bb1de",
    "coral": "#fc6264",
    "grey melange": "#999b99",
    "snow white": "#e9e8e4",
    "army green": "#59593d",
    "sunset orange": "#FD6205",
    "web surf blue": "#1D34A4",
    "neon pink": "#f63868",
    "poison green": "#51d984",
    "sand": "#f3e0d2",
    "caramel": "#9b7659",
    "pear sorbet": "#EDD595",
    "lotus rose": "#E7B7A9",
    "khaki": "#504021",
    "matcha": "#574824",
    "navy blue": "#303746",
    "olive green": "#a09371",
    "light grey": "#ded8db",
    "rose wood": "#d2b9ab",
    "grey velvet": "#434243",
    "wine red": "#7B0323",
    "dark anthracite": "#252729",
    "burgundy dark": "#522937",
    "brown dark": "#493631",
    "light grey melange": "#CCCAC9",
    "cream": "#f0ebdf",
    "light pink": "#e9cfd3",
    "light khaki": "#a09574",
    "solid grey": "#d8d5d2",
    "vanilla ice": "#f0ebdf",
    "cloud dancer": "#E1D8C5",
    "lavender": "#E4CEF2",
    "cocoa": "#5C3B2E",
    "anthracite": "#383E42",
    "graphit": "#7b7670",
    "purple": "#b94ba1",
    "winter colors": "#5e2e3f",
    "rose pink": "#FF80AB",
    "white on black": "#000000",
    "light khaki on white": "#504021",
    "red on white": "#C21E1E",
    "cream logo and stripe on white": "#f0ebdf",
    "white logo on cream": "#f0ebdf",
    "cream on white": "#f0ebdf",
    "baby pink on white": "#F4C2C2",
    "black on white": "#F5F5F0",
    "3er mixed colors": "#FF80AB"
  };

  function normalize(str) {
    return (str || "")
      .toLowerCase()
      .replace(/-.*$/, '')
      .replace(/[_-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function hasImageBackground(el) {
    const inline = el.style.backgroundImage;
    const cssVar = getComputedStyle(el).getPropertyValue('--swatch-background');
    return (inline && inline.includes('url(')) || (cssVar && cssVar.includes('url('));
  }

  function applyColor(el, color) {
    if (el.classList.contains('swatch')) {
      el.style.setProperty('--swatch-background', color);
      el.classList.remove('swatch--unavailable');
    } else {
      el.style.backgroundColor = color;
    }
  }

  function processElement(el) {
    if (hasImageBackground(el)) return;

    let label = '';

    // PDP swatch
    const input = el.closest('label')?.querySelector('input');
    if (input) {
      label = input.getAttribute('aria-label') || input.value;
    }

    // product cards / cart
    if (!label) {
      label = el.getAttribute('aria-label');
    }

    const key = normalize(label);

    if (COLOR_MAP[key]) {
      applyColor(el, COLOR_MAP[key]);
    }
  }

  function applySwatches() {
    document.querySelectorAll('.swatch').forEach(processElement);
    document.querySelectorAll('[data-swatch]').forEach(processElement);
    document.querySelectorAll('[data-ai-card-swatch]').forEach(processElement);
  }

  /* =========================
     OBSERVER (handles cart, ajax, drawer)
  ========================= */
  const observer = new MutationObserver(() => {
    applySwatches();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('DOMContentLoaded', applySwatches);
})();



class CustomProductCard extends HTMLElement {
  connectedCallback() {
    this.init();
    this.setupMoreButton();
  }

  init() {
    this.swatches = this.querySelectorAll('.custom-product-card-swatch__radio');
    this.image = this.querySelector('[data-product-image]');
    this.links = this.querySelectorAll('[data-product-link]');
    this.priceEl = this.querySelector('[data-price]');
    this.compareEl = this.querySelector('[data-compare-price]');
    this.priceContainer = this.querySelector('[data-price-container]');

    console.debug('[CustomProductCard] init', {
      swatches: this.swatches.length,
      image: this.image,
      links: this.links.length,
      priceEl: this.priceEl,
      compareEl: this.compareEl,
    });

    if (!this.swatches.length) return;

    this.swatches.forEach((radio) => {
      radio.addEventListener('change', () => this.onChange(radio));
    });
  }

  onChange(radio) {
    if (!radio.checked) return;
      
  
this.swatches.forEach((r) => {
  const label = this.querySelector(`label[for="${r.id}"]`);
  if (label) label.classList.remove('is-active-swatch');
});


const activeLabel = this.querySelector(`label[for="${radio.id}"]`);
if (activeLabel) activeLabel.classList.add('is-active-swatch');


    const variantId = radio.dataset.variantId;
    const imageUrl = radio.dataset.imageUrl;
    const price = radio.dataset.price;
    const compare = radio.dataset.compare; 

    console.debug('[CustomProductCard] onChange fired', {
      variantId,
      imageUrl,
      price,
      compare,
      radio,
    });

    // ✅ IMAGE UPDATE
    if (this.image && imageUrl) {
  const absoluteUrl = imageUrl.startsWith('//')
    ? `https:${imageUrl}`
    : imageUrl;

  // add fade out
  this.image.classList.add('is-changing');

  // wait for fade out
  setTimeout(() => {
    this.image.src = absoluteUrl;
    this.image.srcset = '';

    // fade back in
    this.image.onload = () => {
      this.image.classList.remove('is-changing');
    };
  }, 150);
}

    // ✅ PRICE UPDATE
    if (this.priceEl) {
      if (price !== undefined && price !== '') {
        const formatted = this.formatMoney(price);
        console.debug('[CustomProductCard] Updating price to:', formatted);
        this.priceEl.textContent = formatted;
      } else {
        console.warn('[CustomProductCard] No data-price on swatch');
      }
    }

    // ✅ COMPARE PRICE UPDATE
    if (this.compareEl) {
      if (compare && Number(compare) > Number(price)) {
        const formatted = this.formatMoney(compare);
        console.debug('[CustomProductCard] Updating compare price to:', formatted);
        this.compareEl.textContent = formatted;
        this.compareEl.style.display = 'inline'; // ✅ FIXED: was broken markdown link syntax
      } else {
        console.debug('[CustomProductCard] No valid compare price, hiding element');
        this.compareEl.style.display = 'none'; // ✅ FIXED: was broken markdown link syntax
      }
    }

    // ✅ UPDATE LINKS
    if (variantId) {
      this.links.forEach((link) => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', variantId);
        const newHref = url.toString();
        console.debug('[CustomProductCard] Updating link href to:', newHref);
        link.href = newHref;
      });
    } else {
      console.warn('[CustomProductCard] No variantId found on swatch');
    }

    // ✅ UPDATE DATORA
    if (this.priceContainer) {
      this.priceContainer.setAttribute('data-datora-vid', variantId || '');
      this.priceContainer.setAttribute('data-datora-price', price || '');
      this.priceContainer.setAttribute('data-datora-compare', compare || '');
      console.debug('[CustomProductCard] Updated datora attributes');
    }
  }

  formatMoney(cents) {
    return `$${(Number(cents) / 100).toFixed(2)}`;
  }
 
  setupMoreButton() {
  const maxVisible = 6;

  const swatchContainer = this.querySelector('.custom-product-card-swatches');
  if (!swatchContainer) return;

 
  const swatchWrappers = Array.from(
    swatchContainer.querySelectorAll('.custom-product-card-swatch')
  );

  if (swatchWrappers.length <= maxVisible) return;

  const hiddenCount = swatchWrappers.length - maxVisible;

  swatchWrappers.forEach((wrapper, index) => {
    if (index >= maxVisible) {
      wrapper.style.display = 'none';
    }
  });

  const moreBtn = document.createElement('button');
  moreBtn.type = 'button';
  moreBtn.className = 'custom-product-card__more';
  moreBtn.textContent = `+${hiddenCount}`;

  moreBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    swatchWrappers.forEach((wrapper) => {
      wrapper.style.display = '';
    });

    moreBtn.remove();
  });

  swatchContainer.appendChild(moreBtn);
}


}

if (!customElements.get('custom-product-card')) {
  customElements.define('custom-product-card', CustomProductCard);
}


(function() {
  function money(cents, fmt) {
    var amount = (Number(cents || 0) / 100).toFixed(2);
    return String(fmt || '${{amount}}')
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', String(Math.round(Number(cents || 0) / 100)))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  }

  var PPF_DATORA_BADGE_SVG =
    '<svg aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M13.25 4.25H11.2759C10.4606 4.25 9.68048 4.58181 9.11496 5.16908L4.86136 9.58629C4.10538 10.3713 4.11713 11.6171 4.88778 12.3878L7.78569 15.2857C8.46001 15.96 9.55008 15.9703 10.237 15.3088L14.9841 10.7375C15.4735 10.2663 15.75 9.61613 15.75 8.93673V6.75C15.75 5.36929 14.6307 4.25 13.25 4.25Z" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<circle cx="13" cy="7" r="1" fill="currentColor"/></svg>';

  function buildPpfPriceInnerHtml(variant, fmt) {
    var cmpAt = Number(variant.compare_at_price || 0);
    var priceC = Number(variant.price || 0);
    var hasCompare = cmpAt > priceC;
    var badge =
      '<p hidden class="datora discount-badge">' + PPF_DATORA_BADGE_SVG + '<span data-datora></span></p>';
    if (hasCompare) {
      var pct = Math.round(((cmpAt - priceC) / cmpAt) * 100);
      return (
        '<div class="ppf-price-line">' +
          '<div class="price__regular price__hidden">' +
          '<span class="price" data-datora-classes="price-item--sale price">' +
          money(priceC, fmt) +
          '</span>' +
          '<span class="hidden" data-datora-classes="price-item--regular compare-at-price"><span></span></span>' +
          '</div>' +
          '<div class="price__sale">' +
          '<span class="price-item__group"><span class="price-item--sale price">' +
          money(priceC, fmt) +
          '</span></span>' +
          '<span class="price-item__group"><span class="price-item--regular compare-at-price">' +
          money(cmpAt, fmt) +
          '</span></span>' +
          '</div>' +
          '<span class="ppf-badge">Save ' +
          pct +
          '%</span>' +
          '</div>' +
          badge
      );
    }
    return (
      '<div class="ppf-price-line">' +
        '<div class="price__regular">' +
        '<span class="price" data-datora-classes="price-item--sale price">' +
        money(priceC, fmt) +
        '</span>' +
        '<span class="hidden" data-datora-classes="price-item--regular compare-at-price"><span></span></span>' +
        '</div>' +
        '<div class="price__sale price__hidden">' +
        '<span class="price-item__group"><span class="price-item--regular compare-at-price"></span></span>' +
        '<span class="price-item__group"><span class="price-item--sale price"></span></span>' +
        '</div>' +
        '</div>' +
        badge
    );
  }

  function applyPpfPriceDom(priceEl, variant, fmt) {
    if (!priceEl || !variant) return;
    priceEl.setAttribute('data-datora-vid', String(variant.id));
    priceEl.setAttribute('data-datora-price', String(variant.price));
    priceEl.setAttribute('data-datora-compare', String(variant.compare_at_price || 0));
    priceEl.innerHTML = buildPpfPriceInnerHtml(variant, fmt);
    if (typeof updateProductGridDiscounts === 'function') {
      updateProductGridDiscounts();
    }
  }

  window.applyPpfPriceDom = applyPpfPriceDom;

  function esc(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(String(value));
    }
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function initPopupProductForms(scope) {
    scope.querySelectorAll('popup-product-form[data-product-id]').forEach(function(root) {
      if (root.dataset.ppfInitialized === 'true') return;
      root.dataset.ppfInitialized = 'true';

      var pid = root.dataset.productId;
      var dataEl = scope.querySelector('#ppf-data-' + pid) || document.getElementById('ppf-data-' + pid);
      if (!dataEl) return;

      var data;
      try {
        data = JSON.parse(dataEl.textContent || '{}');
        var hiddenVariantIds = new Set((data.hiddenVariantIds || []).map(function(id) { return String(id); }));
        data.variants = (data.variants || []).filter(function(v) {
          return !hiddenVariantIds.has(String(v.id));
        });
      } catch (e) {
        console.error('[PPF] invalid JSON data', e);
        return;
      }

      var selections = {};
      var lastVariantId = null;
      var nativeMedia = Array.isArray(data.media) ? data.media.slice() : [];
      var activeMedia = nativeMedia.slice();
      var usingMetaGallery = false;
      root.querySelectorAll('[data-opt].is-selected').forEach(function(btn) {
        selections[btn.dataset.opt] = btn.dataset.val;
      });
      (data.options || []).forEach(function(opt) {
        var pos = String(opt.position);
        if (selections[pos] != null) return;
        var selected = opt.selected;
        if (selected && typeof selected === 'object' && selected.value != null) {
          selected = selected.value;
        }
        if (selected != null) selections[pos] = String(selected);
      });

      function resolveVariant() {
        var byOptions = (data.variants || []).find(function(v) {
          return (data.options || []).every(function(opt) {
            var pos = String(opt.position);
            var selected = selections[pos] != null ? selections[pos] : opt.selected;
            if (selected && typeof selected === 'object' && selected.value != null) {
              selected = selected.value;
            }
            return v['option' + opt.position] === selected;
          });
        });
        if (byOptions) return byOptions;
        if (data.currentVariantId != null) {
          var byId = (data.variants || []).find(function(v) { return String(v.id) === String(data.currentVariantId); });
          if (byId) return byId;
        }
        return (data.variants || [])[0] || null;
      }

      function setMainImage(src) {
        var img = document.getElementById('ppf-main-img-' + pid);
        if (!img || !src || img.src === src) return;
        img.style.opacity = '0';
        img.src = src;
        img.onload = function() { img.style.opacity = '1'; };
      }

      function setMainImageByVariant(variant) {
        if (!variant || !variant.featured_image || !variant.featured_image.src) return;
        var thumbsEl = document.getElementById('ppf-thumbs-' + pid);
        var thumb = null;
        if (thumbsEl && variant.featured_image.id) {
          thumb = thumbsEl.querySelector('.ppf-gallery__thumb[data-src*="' + variant.featured_image.id + '"]');
        }
        if (thumb) {
          setMainImage(thumb.dataset.src);
          thumbsEl.querySelectorAll('.ppf-gallery__thumb').forEach(function(t) {
            t.classList.remove('is-active');
          });
          thumb.classList.add('is-active');
        } else {
          setMainImage(variant.featured_image.src);
        }
      }

      function renderThumbButtons() {
        var thumbsEl = document.getElementById('ppf-thumbs-' + pid);
        if (!thumbsEl) return;
        thumbsEl.innerHTML = activeMedia.map(function(m, i) {
          return (
            '<button class="ppf-gallery__thumb' + (i === 0 ? ' is-active' : '') + '" type="button" data-src="' + m.src + '" data-index="' + i + '" aria-label="Product image ' + (i + 1) + '">' +
            '<img src="' + (m.thumb || m.src) + '" alt="" loading="lazy">' +
            '</button>'
          );
        }).join('');
      }

      function applyMetafieldGallery(variant) {
        var metaMap = data.variantMetaGallery || {};
        var meta = metaMap[String(variant.id)];
        var shouldUseMeta = !!(meta && meta.hasMetafieldImages && Array.isArray(meta.images) && meta.images.length);
        usingMetaGallery = shouldUseMeta;
        var nextMedia = shouldUseMeta
          ? meta.images.map(function(src, i) {
              return { id: 'meta-' + variant.id + '-' + i, mediaType: 'image', alt: data.title || '', src: src, thumb: src };
            })
          : nativeMedia.slice();

        var prevKey = activeMedia.map(function(m) { return m.src; }).join('|');
        var nextKey = nextMedia.map(function(m) { return m.src; }).join('|');
        if (prevKey === nextKey) return;

        activeMedia = nextMedia.slice();
        renderThumbButtons();
        if (activeMedia[0] && activeMedia[0].src) setMainImage(activeMedia[0].src);
      }

      function refreshAvailability() {
        (data.options || []).forEach(function(opt) {
          var isColorOption = /colou?r/i.test(String(opt.name || ''));
          var other = Object.assign({}, selections);
          delete other[String(opt.position)];

          (opt.values || []).forEach(function(valObj) {
            var testSel = Object.assign({}, other);
            testSel[String(opt.position)] = valObj.value;
            var matchingVariants = (data.variants || []).filter(function(vr) {
              return (data.options || []).every(function(o) {
                var wanted = testSel[String(o.position)] != null ? testSel[String(o.position)] : o.selected;
                return vr['option' + o.position] === wanted;
              });
            });
            var exists = matchingVariants.length > 0;
            var isAvailable = matchingVariants.some(function(vr) { return !!vr.available; });

            var btn = root.querySelector('[data-opt="' + opt.position + '"][data-val="' + esc(valObj.value) + '"]');
            if (!btn) return;

            if (isColorOption) {
              btn.classList.toggle('is-disabled', !isAvailable);
            } else {
              btn.classList.toggle('is-disabled', !exists);
            }
          });
        });
      }

      function syncColorSectionLabel(position, value, selectedBtn) {
        if (!selectedBtn || !selectedBtn.classList.contains('ppf-swatch')) return;
        var optionGroup = root.querySelector('[data-option-position="' + position + '"]');
        if (!optionGroup) return;
        optionGroup.querySelectorAll('.ppf-option-value--color-target').forEach(function(el) {
          el.textContent = '';
        });
        var section = selectedBtn.closest('.ppf-color-section');
        var target = section ? section.querySelector('.ppf-option-value--color-target') : null;
        if (target) target.textContent = value;
      }

      function updateState() {
        var variant = resolveVariant();
        var btn = document.getElementById('ppf-atc-' + pid);
        var priceEl = document.getElementById('ppf-price-' + pid);

        if (!variant) {
          if (btn) {
            btn.textContent = 'Unavailable';
            btn.disabled = true;
          }
          refreshAvailability();
          return;
        }

        if (priceEl) {
          applyPpfPriceDom(priceEl, variant, data.moneyFormat);
        }

        applyMetafieldGallery(variant);

        if (!usingMetaGallery && String(variant.id) !== lastVariantId) {
          setMainImageByVariant(variant);
        }
        lastVariantId = String(variant.id);

        if (btn) {
          if (variant.available) {
            btn.textContent = 'Add to Cart';
            btn.disabled = false;
          } else {
            btn.textContent = 'Sold Out';
            btn.disabled = true;
          }
        }

        root.dispatchEvent(new CustomEvent('ppf:variant-changed', { bubbles: true, detail: { variant: variant } }));
        refreshAvailability();
      }

      root.querySelectorAll('[data-opt][data-val]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          if (btn.classList.contains('is-disabled')) return;
          var position = String(btn.dataset.opt);
          var value = btn.dataset.val;
          selections[position] = value;

          var listParent = btn.closest('.ppf-swatch-list, .ppf-block-list');
          if (listParent) {
            listParent.querySelectorAll('[data-opt]').forEach(function(b) {
              b.classList.remove('is-selected');
              b.setAttribute('aria-pressed', 'false');
            });
          }
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');

          var label = document.getElementById('ppf-oval-' + pid + '-' + position);
          if (label) label.textContent = value;
          syncColorSectionLabel(position, value, btn);

          if (!btn.classList.contains('ppf-swatch') && btn.dataset.variantImg) {
            setMainImage(btn.dataset.variantImg);
          }
          updateState();
        });
      });

      var thumbsEl = document.getElementById('ppf-thumbs-' + pid);
      if (thumbsEl) {
        thumbsEl.addEventListener('click', function(e) {
          var btn = e.target.closest('.ppf-gallery__thumb');
          if (!btn) return;
          setMainImage(btn.dataset.src);
          thumbsEl.querySelectorAll('.ppf-gallery__thumb').forEach(function(t) {
            t.classList.remove('is-active');
          });
          btn.classList.add('is-active');
        });
      }

      root.querySelector('[data-upsell-close]')?.addEventListener('click', function() {
        root.dispatchEvent(new CustomEvent('ppf:close', { bubbles: true }));
      });

      var atcBtn = document.getElementById('ppf-atc-' + pid);
      var errEl = document.getElementById('ppf-error-' + pid);
      if (atcBtn) {
        atcBtn.addEventListener('click', async function() {
          var variant = resolveVariant();
          if (!variant || !variant.available) return;

          atcBtn.disabled = true;
          atcBtn.textContent = 'Adding…';
          if (errEl) errEl.hidden = true;

          try {
            var sectionIds = [];
            document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(el) {
              var sid = el.getAttribute('data-section-id');
              if (sid) sectionIds.push(sid);
            });

            var res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: variant.id,
                quantity: 1,
                sections: sectionIds.join(','),
                sections_url: window.location.pathname
              })
            });
            var addResponse = await res.json();
            if (!res.ok) throw new Error(addResponse.description || 'Could not add to cart');

            var cartResource = null;
            try {
              var cartRes = await fetch('/cart.js');
              if (cartRes.ok) cartResource = await cartRes.json();
            } catch (_) {}

            atcBtn.textContent = '✓ Added!';
            atcBtn.classList.add('is-added');

            root.dispatchEvent(new CustomEvent('ppf:added', { bubbles: true, detail: { variant: variant, item: addResponse } }));
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cartResource || addResponse,
                sourceId: 'popup-product-form',
                data: {
                  source: 'popup-product-form',
                  itemCount: (cartResource && cartResource.item_count) || addResponse.item_count || 1,
                  productId: String(data.productId || ''),
                  sections: addResponse.sections || null
                }
              }
            }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

            setTimeout(function() {
              atcBtn.textContent = 'Add to Cart';
              atcBtn.disabled = false;
              atcBtn.classList.remove('is-added');
            }, 2200);
          } catch (err) {
            atcBtn.textContent = 'Add to Cart';
            atcBtn.disabled = false;
            if (errEl) {
              errEl.textContent = err && err.message ? err.message : 'Could not add to cart';
              errEl.hidden = false;
            }
          }
        });
      }

      updateState();
    });
  }

  function initUpsellModal() {
    var modal = document.getElementById('upsell-modal');
    if (!modal) return;

   
    function applyUpsellDiscount(container) {
      var el = container.querySelector('[data-datora-pid]');
      if (!el || typeof co2 === 'undefined' || typeof co2.itemDiscountFull !== 'function') return;
      co2.getDiscountCode().then(function(code) {
        if (!code) return;
        var pid = Number(el.dataset.datoraPid);
        var vid = Number(el.dataset.datoraVid);
        var tags = el.dataset.datoraTags ? el.dataset.datoraTags.split(',') : [];
        var price = Number(el.dataset.datoraPrice);
        var spgid = el.dataset.datoraSpgid || null;
        co2.itemDiscountFull(pid, vid, tags, price, 1, spgid).then(function(data) {
          if (!data) return;
          var validDisc = false;
          var newPrice, badgeText;
          if (data.calc === 'perc' && data.discPerc > 0) {
            validDisc = true;
            newPrice = formatPrice(data.discPrice);
            badgeText = '<b>-' + data.discPerc + '%</b> (' + code.toUpperCase() + ')';
          } else if (data.calc === 'amt' && data.discAmt > 0) {
            validDisc = true;
            var discounted = data.discPrice;
            newPrice = formatPrice(discounted);
            badgeText = '-' + formatPrice(price - discounted) + ' | ' + code.toUpperCase();
          }
          if (validDisc) {
            el.classList.add('discounted');
            var priceContainer =
              typeof getDatoraPriceElement === 'function'
                ? getDatoraPriceElement(el)
                : el.querySelector('.price-list .price:not(.price--compare)');
            if (priceContainer) priceContainer.textContent = newPrice;
            setDatoraClasses(el, formatPrice(price / 100));
            el.querySelector('[data-datora]').innerHTML = badgeText;
            var badge = el.querySelector('.datora.discount-badge');
            if (badge) badge.removeAttribute('hidden');
          }
        });
      });
    }

    
    var drawer = document.getElementById('mini-cart');

    function pauseDrawerTrap() {
      if (drawer && drawer.focusTrap) {
        try { drawer.focusTrap.pause(); } catch(e) {}
      }
    }
    function unpauseDrawerTrap() {
      if (drawer && drawer.focusTrap) {
        try { drawer.focusTrap.unpause(); } catch(e) {}
      }
    }

    function openModal() {
      pauseDrawerTrap();
      document.querySelector('cart-items-component')?.querySelector('.cart-drawer__close-button')?.click();
      modal.hidden = false;
       document.documentElement.style.overflow = 'hidden';
    }
    function closeModal() {
      modal.hidden = true;
      unpauseDrawerTrap();
      document.documentElement.style.overflow = '';
    }

    
    modal.addEventListener('click', function(e) {
      if (e.target.classList.contains('upsell-modal__overlay') || e.target.closest('[data-upsell-close]')) {
        closeModal();
      }
    });

    var isGift = false;

    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-upsell-trigger]');
      if (!trigger) return;
      var content = modal.querySelector('.upsell-modal__content');
      var href = trigger.getAttribute('data-upsell-href');
      isGift = trigger.getAttribute('data-upsell-gift') === 'true';

      if (content.children.length > 0 && href === currentHref && !isGift) {
        initPopupProductForms(content);
        applyUpsellDiscount(content);
        openModal();
        return;
      }

      loadProduct(content, href);
    });
    var currentHref = null;

    function loadProduct(content, href) {
      currentHref = href;
      var loadIsGift = isGift; 
      content.innerHTML = '<div class="upsell-modal__spinner"><span class="spinner">' +
        '<svg width="24" height="24" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none" opacity="0.3"/>' +
        '<path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/></path></svg>' +
        '</span></div>';
      openModal();

      var separator = href.includes('?') ? '&' : '?';
      fetch(href + separator + 'section_id=popup-product-form')
        .then(function(r) { return r.text(); })
        .then(function(html) {
          content.innerHTML = html;
          initPopupProductForms(content);

          
          if (loadIsGift) {
            (function() {
              function ensureGiftInput() {
                var form = content.querySelector('form');
                if (form && !form.querySelector('input[name="properties[_gift]"]')) {
                  var input = document.createElement('input');
                  input.type = 'hidden';
                  input.name = 'properties[_gift]';
                  input.value = '';
                  form.appendChild(input);
                }
              }
              ensureGiftInput();
              new MutationObserver(ensureGiftInput).observe(content, { childList: true, subtree: true });
            })();
          }

          applyUpsellDiscount(content);

          content.addEventListener('ppf:variant-changed', function() {
            applyUpsellDiscount(content);
          });

          content.addEventListener('ppf:added', function() {
            closeModal();
          });

          content.addEventListener('ppf:close', function() {
            closeModal();
          });
        });
    }

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpsellModal);
  } else {
    initUpsellModal();
  }
})();


(function () {

  function el(tag, className, attrs = {}, html = '') {
    const node = document.createElement(tag);
    if (className) node.className = className;
    Object.entries(attrs).forEach(([k, v]) => node.setAttribute(k, v));
    if (html) node.innerHTML = html;
    return node;
  }

  function money(cents, fmt) {
    const amount = (cents / 100).toFixed(2);
    return fmt
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  }

  class PopupProductForm extends HTMLElement {

    connectedCallback() {
      const pid = this.dataset.productId;
      console.log(`[PPF] connectedCallback — productId: ${pid}`);

      const dataEl = document.getElementById(`ppf-data-${pid}`);
      if (!dataEl) {
        console.error(`[PPF] ❌ Data script tag #ppf-data-${pid} NOT FOUND`);
        return;
      }

      try {
        this._data = JSON.parse(dataEl.textContent);
        console.log('[PPF] ✅ Parsed data island:', this._data);
      } catch (e) {
        console.error('[PPF] ❌ JSON parse failed:', e, '\nRaw content:', dataEl.textContent);
        return;
      }

      this._hiddenVariantIds = new Set(
        (this._data.hiddenVariantIds || []).map(id => String(id))
      );

      this._data.variants = (this._data.variants || []).filter(v =>
        !this._hiddenVariantIds.has(String(v.id))
      );

      console.log(`[PPF] Variants after hidden filter: ${this._data.variants.length}`, this._data.variants);

      this._pid = pid;
      this._mediaIndex = 0;
      this._lastVariantId = null;

      this._nativeMedia = Array.isArray(this._data.media) ? [...this._data.media] : [];
      console.log(`[PPF] Native media items: ${this._nativeMedia.length}`, this._nativeMedia);

      this._activeMedia = [...this._nativeMedia];
      this._usingMetaGallery = false;
      this._selections = {};

      this.querySelectorAll('[data-opt].is-selected').forEach(btn => {
        this._selections[btn.dataset.opt] = btn.dataset.val;
      });
      console.log('[PPF] Initial selections:', this._selections);

      this.querySelectorAll('[data-opt][data-val]').forEach(btn => {
        btn.addEventListener('click', () => {
          this._selectOption(btn.dataset.opt, btn.dataset.val, btn);
        });
      });

      this._renderGallery();
      this._updateState();

      this.querySelector('[data-upsell-close]')
        ?.addEventListener('click', () => {
          this.dispatchEvent(new CustomEvent('ppf:close', { bubbles: true }));
        });

      document.getElementById(`ppf-atc-${pid}`)
        ?.addEventListener('click', () => this._addToCart());
    }

    _selectOption(position, value, clickedBtn) {
      console.log(`[PPF] _selectOption — pos:${position} val:"${value}"`);
      if (clickedBtn.classList.contains('is-disabled')) {
        console.warn('[PPF] Clicked button is disabled, ignoring.');
        return;
      }

      this._selections[position] = value;

      const listParent = clickedBtn.closest('.ppf-swatch-list, .ppf-block-list');
      listParent?.querySelectorAll('[data-opt]').forEach(b => {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });

      clickedBtn.classList.add('is-selected');
      clickedBtn.setAttribute('aria-pressed', 'true');

      const lbl = document.getElementById(`ppf-oval-${this._pid}-${position}`);
      if (lbl) lbl.textContent = value;
      this._syncColorSectionLabel(position, value, clickedBtn);

      this._updateState();
    }

    _resolveVariant() {
      const resolved = this._data.variants.find(v =>
        this._data.options.every(opt =>
          v[`option${opt.position}`] === (this._selections[opt.position] ?? opt.selected)
        )
      );
      console.log('[PPF] _resolveVariant —', resolved
        ? `id:${resolved.id} available:${resolved.available}`
        : '❌ No matching variant found');
      console.log('[PPF]   current selections:', this._selections);
      console.log('[PPF]   options expected:', this._data.options.map(o =>
        `pos${o.position}="${this._selections[o.position] ?? o.selected}"`
      ).join(', '));
      return resolved;
    }

    _updateState() {
      const variant = this._resolveVariant();
      const btn = document.getElementById(`ppf-atc-${this._pid}`);
      const priceEl = document.getElementById(`ppf-price-${this._pid}`);

      if (!variant) {
        if (btn) { btn.textContent = 'Unavailable'; btn.disabled = true; }
        return;
      }

      if (priceEl && typeof window.applyPpfPriceDom === 'function') {
        window.applyPpfPriceDom(priceEl, variant, this._data.moneyFormat);
      }

      this._applyMetafieldGallery(variant);

      if (!this._usingMetaGallery && String(variant.id) !== this._lastVariantId) {
        this._setMainImageByVariant(variant);
      }

      this._lastVariantId = String(variant.id);

      if (btn) {
        if (variant.available) {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        } else {
          btn.textContent = 'Sold Out';
          btn.disabled = true;
        }
      }

      this._refreshAvailability();

      this.dispatchEvent(
        new CustomEvent('ppf:variant-changed', { bubbles: true, detail: { variant } })
      );
    }

    _refreshAvailability() {
      this._data.options.forEach(opt => {
        const otherSelections = { ...this._selections };
        delete otherSelections[opt.position];

        opt.values.forEach(v => {
          const testSel = { ...otherSelections, [opt.position]: v.value };
          const matchingVariants = this._data.variants.filter(vr =>
            this._data.options.every(o =>
              vr[`option${o.position}`] === (testSel[o.position] ?? o.selected)
            )
          );
          const exists = matchingVariants.length > 0;
          const b = this.querySelector(
            `[data-opt="${opt.position}"][data-val="${CSS.escape(v.value)}"]`
          );
          if (!b) return;
          b.classList.toggle('is-disabled', !exists);
        });
      });
    }

    _syncColorSectionLabel(position, value, selectedBtn) {
      if (!selectedBtn?.classList?.contains('ppf-swatch')) return;
      const optionGroup = this.querySelector(`[data-option-position="${position}"]`);
      if (!optionGroup) return;
      optionGroup.querySelectorAll('.ppf-option-value--color-target').forEach((el) => {
        el.textContent = '';
      });
      const section = selectedBtn.closest('.ppf-color-section');
      const target = section?.querySelector('.ppf-option-value--color-target');
      if (target) target.textContent = value;
    }

    _renderGallery() {
      console.log('[PPF] _renderGallery called');

      const root = this.querySelector(`#ppf-gallery-${this._pid}`);
      if (!root) {
        console.error(`[PPF] ❌ Gallery root #ppf-gallery-${this._pid} NOT FOUND in DOM`);
        return;
      }
      console.log('[PPF] ✅ Gallery root found:', root);

      const stage = root.querySelector('.ppf-gallery__stage');
      console.log('[PPF] Gallery stage:', stage || '❌ NOT FOUND');

      const mainImg = this.querySelector(`#ppf-main-img-${this._pid}`);
      console.log('[PPF] Main img element:', mainImg ? `src="${mainImg.src}"` : '❌ NOT FOUND');

      // ── CHECK: is activeMedia populated? ──────────────────────────────
      console.log(`[PPF] _activeMedia at render time: ${this._activeMedia.length} items`);
      if (this._activeMedia.length === 0) {
        console.warn('[PPF] ⚠️ _activeMedia is empty — gallery thumbnails will not render. Check that product.media is populated in the data island.');
      } else {
        this._activeMedia.forEach((m, i) =>
          console.log(`[PPF]   media[${i}] id:${m.id} type:${m.mediaType} src:${m.src}`)
        );
      }

      // ── Nav buttons ───────────────────────────────────────────────────
      const prevBtn = root.querySelector('.ppf-gallery__nav--prev');
      const nextBtn = root.querySelector('.ppf-gallery__nav--next');
      console.log('[PPF] Nav prev:', prevBtn || '❌ NOT FOUND');
      console.log('[PPF] Nav next:', nextBtn || '❌ NOT FOUND');

      this._galleryPrevBtn = prevBtn;
      this._galleryNextBtn = nextBtn;

      const step = (dir) => {
        if (!this._activeMedia.length) {
          console.warn('[PPF] step() called but _activeMedia is empty');
          return;
        }
        this._mediaIndex =
          (this._mediaIndex + dir + this._activeMedia.length) % this._activeMedia.length;
        console.log(`[PPF] Gallery step ${dir > 0 ? '→' : '←'} → index: ${this._mediaIndex}`);
        this._setMainImage(this._activeMedia[this._mediaIndex].src);
      };

      prevBtn?.addEventListener('click', () => step(-1));
      nextBtn?.addEventListener('click', () => step(1));

      this._syncGalleryNavVisibility();

      if (stage) {
        let touchStartX = 0;
        stage.addEventListener('touchstart', (e) => {
          touchStartX = e.changedTouches?.[0]?.clientX || 0;
        }, { passive: true });
        stage.addEventListener('touchend', (e) => {
          const touchEndX = e.changedTouches?.[0]?.clientX || 0;
          const deltaX = touchStartX - touchEndX;
          if (Math.abs(deltaX) < 30) return;
          step(deltaX > 0 ? 1 : -1);
        }, { passive: true });
      }

      mainImg?.addEventListener('click', () => this._openLightbox());
    }


    _setMainImage(src) {
      console.log(`[PPF] _setMainImage → ${src}`);
      const img = this.querySelector(`#ppf-main-img-${this._pid}`);
      if (!img) {
        console.error('[PPF] ❌ Main img element not found in _setMainImage');
        return;
      }
      img.style.opacity = '0';
      requestAnimationFrame(() => {
        img.src = src;
        img.onload = () => {
          img.style.opacity = '1';
          console.log('[PPF] ✅ Main image loaded:', src);
        };
        img.onerror = () => {
          console.error('[PPF] ❌ Main image failed to load:', src);
          img.style.opacity = '1';
        };
      });

      const currentIndex = this._activeMedia.findIndex(m => m.src === src);
      if (currentIndex >= 0) {
        this._mediaIndex = currentIndex;
        this._syncThumbActive();
      } else {
        console.warn(`[PPF] ⚠️ src not found in _activeMedia: ${src}`);
      }
    }

    _setMainImageByVariant(variant) {
      console.log(`[PPF] _setMainImageByVariant — variant id:${variant.id}`, variant.featured_image);
      if (!variant.featured_image?.src) {
        console.warn('[PPF] Variant has no featured_image.src');
        return;
      }
      const idx = this._activeMedia.findIndex(m => m.src === variant.featured_image.src);
      console.log(`[PPF] Variant image index in _activeMedia: ${idx}`);
      if (idx >= 0) {
        this._mediaIndex = idx;
        this._setMainImage(this._activeMedia[idx].src);
      } else {
        this._mediaIndex = 0;
        this._setMainImage(variant.featured_image.src);
      }
    }

    _applyMetafieldGallery(variant) {
      const meta = this._data.variantMetaGallery?.[String(variant.id)];
      console.log(`[PPF] _applyMetafieldGallery — variant:${variant.id}`, meta);

      const shouldUseMeta = !!(
        meta && meta.hasMetafieldImages &&
        Array.isArray(meta.images) && meta.images.length > 0
      );
      console.log(`[PPF] shouldUseMeta: ${shouldUseMeta}`);

      this._usingMetaGallery = shouldUseMeta;

      const nextMedia = shouldUseMeta
        ? meta.images.map((src, i) => ({
            id: `meta-${variant.id}-${i}`,
            mediaType: 'image',
            alt: this._data.title || '',
            src,
            thumb: src
          }))
        : this._nativeMedia;

      const prevKey = this._activeMedia.map(m => m.src).join('|');
      const nextKey = nextMedia.map(m => m.src).join('|');
      console.log(`[PPF] Media key changed: ${prevKey !== nextKey}`);

      if (prevKey === nextKey && this._activeMedia.length > 0) {
        this._syncGalleryNavVisibility();
        if (this._activeMedia[this._mediaIndex]?.src) {
          this._setMainImage(this._activeMedia[this._mediaIndex].src);
        }
        return;
      }

      this._activeMedia = [...nextMedia];
      this._mediaIndex = 0;
      console.log(`[PPF] _activeMedia updated — ${this._activeMedia.length} items`);

      this._syncGalleryNavVisibility();

      if (this._activeMedia[0]?.src) {
        this._setMainImage(this._activeMedia[0].src);
      }
    }

    _syncGalleryNavVisibility() {
      const hasMultiple = (this._activeMedia?.length || 0) > 1;
      console.log(`[PPF] _syncGalleryNavVisibility — hasMultiple: ${hasMultiple}`);
      if (this._galleryPrevBtn) this._galleryPrevBtn.hidden = !hasMultiple;
      if (this._galleryNextBtn) this._galleryNextBtn.hidden = !hasMultiple;
    }

    _openLightbox() {
      const img = this.querySelector(`#ppf-main-img-${this._pid}`);
      const src = img?.src;
      console.log(`[PPF] _openLightbox — src: ${src}`);
      if (!src) return;

      const overlay = el('div', 'ppf-lightbox', { role: 'dialog', 'aria-modal': 'true' });
      const inner  = el('div', 'ppf-lightbox__inner');
      const close  = el('button', 'ppf-lightbox__close', { type: 'button', 'aria-label': 'Close' }, '&times;');
      const image  = el('img', 'ppf-lightbox__img', { src, alt: '' });
      const prev   = el('button', 'ppf-lightbox__nav ppf-lightbox__nav--prev', { type: 'button', 'aria-label': 'Previous' }, '‹');
      const next   = el('button', 'ppf-lightbox__nav ppf-lightbox__nav--next', { type: 'button', 'aria-label': 'Next' }, '›');

      inner.append(image, close, prev, next);
      overlay.appendChild(inner);
      document.body.appendChild(overlay);
      requestAnimationFrame(() => overlay.classList.add('is-open'));

      const nav = (dir) => {
        const media = this._activeMedia;
        this._mediaIndex = (this._mediaIndex + dir + media.length) % media.length;
        console.log(`[PPF] Lightbox nav ${dir > 0 ? '→' : '←'} → index: ${this._mediaIndex}`);
        image.style.opacity = '0';
        image.src = media[this._mediaIndex].src;
        image.onload = () => { image.style.opacity = '1'; };
      };

      const removeLb = () => {
        overlay.classList.remove('is-open');
        overlay.addEventListener('transitionend', () => overlay.remove(), { once: true });
      };

      close.addEventListener('click', removeLb);
      overlay.addEventListener('click', e => { if (e.target === overlay) removeLb(); });
      prev.addEventListener('click', () => nav(-1));
      next.addEventListener('click', () => nav(1));
    }

    async _addToCart() {
      const variant = this._resolveVariant();
      const btn    = document.getElementById(`ppf-atc-${this._pid}`);
      const errEl  = document.getElementById(`ppf-error-${this._pid}`);

      if (!variant || !variant.available) return;

      btn.disabled = true;
      btn.textContent = 'Adding…';
      if (errEl) errEl.hidden = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variant.id, quantity: 1 })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || 'Could not add to cart');

        btn.textContent = '✓ Added!';
        btn.classList.add('is-added');
        console.log('[PPF] ✅ Added to cart — variant:', variant.id);

        setTimeout(() => {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
          btn.classList.remove('is-added');
        }, 2200);
      } catch (err) {
        console.error('[PPF] ❌ Add to cart error:', err);
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
        if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
      }
    }
  }

  if (!customElements.get('popup-product-form')) {
    customElements.define('popup-product-form', PopupProductForm);
  }

})();